import { getServerApi } from '../../../config/deployment'
import { getCurrentUserToken } from '../../auth/services/authService'

import { performRequest_GET, performRequest_PUT, performRequest_POST } from '../../utils/http/httpService'

let envUri = getServerApi()
let propertyPersonsUri = envUri + '/api/persons/property'
let propertyGuideUri = envUri + '/api/listings/v2/properties/guides'
let propertyAccountingUri = envUri + '/api/listings/v2/properties/accounting'


export const getPropertyAccountingPeriod=async (propertyId)=>{
  var token = await getCurrentUserToken()
  var resp = await performRequest_GET(propertyAccountingUri, {propertyId:propertyId}, { "Authorization": token })
  if(!resp.success) return {}
  var response = resp.response
  const { data: { body } = {} } = response;
  if(body) return body.accountingPeriod || {}
  else return {}
}

export const upsertPropertyAccountingPeriod=async (propertyId, accountingPeriod)=>{
  const token = await getCurrentUserToken()
  const data = {
    propertyId: propertyId,
    accountingPeriod: accountingPeriod
  }
  var resp = await performRequest_POST(propertyAccountingUri, data, { "Authorization": token })
  if(resp.success) return true
  else return false
}

export const getPropertyGuides=async (propertyId)=>{
  var token = await getCurrentUserToken()
  var resp = await performRequest_GET(propertyGuideUri, {propertyId:propertyId}, { "Authorization": token })
  if(!resp.success) return {}
  var response = resp.response
  const { data: { body } = {} } = response;
  if(body) return body.guides || {}
  else return {}
}

export const upsertPropertyGuides=async (propertyId, guides)=>{
  const token = await getCurrentUserToken()
  const data = {
    propertyId: propertyId,
    guides: guides
  }
  var resp = await performRequest_POST(propertyGuideUri, data, { "Authorization": token })
  if(resp.success) return true
  else return false
}

export const getRepresentatives=(propertyId)=>{
  return new Promise((resolve, reject) => {
    performRequest_GET(propertyPersonsUri, {propertyId:propertyId})
      .then(resp => {
        if (resp.success) resolve(resp.response.data.body)
        else reject(resp.error)
      })
      .catch(err => {
        reject(err)
      })
  })
}

export const upsertRepresentatives=(repCommand)=>{
    return new Promise((resolve, reject) => {
        performRequest_PUT(propertyPersonsUri, repCommand)
          .then(resp => {
            if (resp.success) resolve(resp.response.data.body)
            else reject(resp.error)
          })
          .catch(err => {
            reject(err)
          })
      })
}



// WEBPACK FOOTER //
// ./src/platform/properties/repository/propertyRepository.js